import FullLogo from "@/assets/svg/full-logo/task.svg";
import MailSVG from "@/assets/svg/task/icons/mail.svg";
import SupportSVG from "@/assets/svg/task/icons/support.svg";
import TelegramSVG from "@/assets/svg/task/icons/telegram.svg";
import WhatsappSVG from "@/assets/svg/task/icons/whatsapp.svg";
import YoutubeSVG from "@/assets/svg/task/icons/youtube.svg";
import scrollTo from "@/utils/scrollTo";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SupportTicket from "../SupportTicket";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";
  const isContactUs = location.pathname === "/contact-us";
  const isCaseStudy = location.pathname === "/case-study-1";
  const isCaseStudy2 = location.pathname === "/case-study-2";

  const [modalOpen, setModalOpen] = useState(false);

  const socialPlatforms = [
    {
      icon: MailSVG,
      name: "Email",
      url: "https://mail.google.com/mail/?view=cm&fs=1&to=requests@enfinity.com",
    },
    {
      icon: TelegramSVG,
      name: "Telegram",
      url: "https://web.telegram.org/a/#6110481522",
    },
    {
      icon: YoutubeSVG,
      name: "Telegram",
      url: "https://www.youtube.com/@enfinity",
    },
    {
      icon: WhatsappSVG,
      name: "WhatsApp",
      url: "https://api.whatsapp.com/send/?phone=639291514853",
    },
    {
      icon: SupportSVG,
      name: "WhatsApp",
      action: () => setModalOpen(true),
    },
  ];

  const goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNavClick = (targetPath, scrollId) => {
    if (location.pathname === targetPath) {
      scrollTo(scrollId);
    } else {
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollTo(location.state.scrollTo);
        navigate(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location, navigate]);

  return (
    <>
      <div className="space-y-14 px-8 lg:px-16 py-12 4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-between ">
          <div className="space-y-8 mb-8">
            <Link to="/">
              <img
                src={FullLogo}
                className="mx-auto lg:hidden"
                alt="EnfiniTask Logo"
              />
            </Link>
            <p className="text-white text-center md:max-w-lg lg:hidden">
              From all-in-one subscription bundles to flexible pay-as-you-go
              requests, Enfinitask adapts to your workflow.
            </p>
            <p className="text-white text-center md:max-w-lg lg:hidden">
              Scale your content with video editing, thumbnail design, and
              channel support—on your terms.
            </p>
          </div>
          <div className="space-y-8 order-2 lg:order-1 mb-auto">
            <Link to="/">
              <img
                src={FullLogo}
                className="hidden lg:block w-52"
                alt="EnfiniTask Logo"
              />
            </Link>
            <p className="text-white hidden lg:block">
              From all-in-one subscription bundles to flexible pay-as-you-go
              requests, Enfinitask adapts to your workflow.
            </p>
            <p className="text-white hidden lg:block">
              Scale your content with video editing, thumbnail design, and
              channel support—on your terms.
            </p>
            <div className="flex items-center justify-center lg:justify-start gap-4">
              {socialPlatforms.map((platform, index) =>
                platform.action ? (
                  <div
                    key={index}
                    className="rounded-lg py-2 px-3 xs:px-4 bg-transparent border border-white hover:bg-primary"
                    onClick={platform.action}
                  >
                    <img
                      src={platform.icon}
                      className="w-auto h-6"
                      alt={platform.name}
                    />
                  </div>
                ) : (
                  <a key={index} href={platform.url} target="_blank">
                    <div className="rounded-lg py-2 px-3 xs:px-4 bg-transparent border border-white hover:bg-primary">
                      <img
                        src={platform.icon}
                        className="w-auto h-6"
                        alt={platform.name}
                      />
                    </div>
                  </a>
                )
              )}
            </div>
            <div className="space-y-1">
              <p className="text-white text-center lg:text-left">
                Where creator grows with the power of people
              </p>
              <p className="text-white/50 italic text-center lg:text-left">
                a division of Enfinity Limited
              </p>
            </div>
            <p className="text-white text-center lg:text-left">
              © 2025 Enfinity Limited. All Rights Reserved
            </p>
          </div>
          <div className="flex flex-col lg:flex-row lg:flex-wrap xl:justify-end gap-10 cursor-default text-center lg:text-left order-1 lg:order-2 w-full">
            <div className="space-y-3 w-full lg:w-72">
              <h6 className="text-primary font-medium">Menu</h6>
              <div className="text-white space-y-3">
                {isHome ? (
                  <p
                    onClick={() => goUp()}
                    className="cursor-pointer hover:underline"
                  >
                    Home
                  </p>
                ) : (
                  <Link to={"/"} className="cursor-pointer hover:underline">
                    <p>Home</p>
                  </Link>
                )}
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => {
                    if (isContactUs) {
                      handleNavClick("/", "workflows");
                    } else {
                      scrollTo("workflows");
                    }
                  }}
                >
                  Features
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleNavClick("/", "how-it-works")}
                >
                  How it works
                </p>
                {isCaseStudy ? (
                  <p
                    onClick={() => goUp()}
                    className="cursor-pointer hover:underline"
                  >
                    Case studies
                  </p>
                ) : (
                  <Link
                    to={"/case-study-1"}
                    className="cursor-pointer hover:underline block"
                  >
                    <p>Case studies</p>
                  </Link>
                )}
                {isContactUs ? (
                  <p
                    onClick={() => goUp()}
                    className="cursor-pointer hover:underline"
                  >
                    Contact us
                  </p>
                ) : (
                  <Link
                    to={"/contact-us"}
                    className="cursor-pointer hover:underline block"
                  >
                    <p>Contact us</p>
                  </Link>
                )}
              </div>
            </div>
            <div className="space-y-3 w-full lg:w-72">
              <h6 className="text-primary font-medium">Roles</h6>
              <div className="text-white space-y-3">
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent(
                    "Creative & Production"
                  )}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Creative & Production
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent("Growth & Strategy")}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Growth & Strategy
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent(
                    "Communications & Collaboration"
                  )}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Communications & Collaboration
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent("Research & Support")}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Research & Support
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent(
                    "Technical & Platform Support"
                  )}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Technical & Platform Support
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent(
                    "Monetization & Business"
                  )}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Monetization & Business
                  </p>
                </Link>
                <Link
                  className="block"
                  to={`/talent-hub/${encodeURIComponent(
                    "Specialized & High-Value Roles"
                  )}`}
                >
                  <p className="cursor-pointer hover:underline">
                    Specialized & High-Value Roles
                  </p>
                </Link>
              </div>
            </div>
            <div className="space-y-3 w-full lg:w-72">
              <h6 className="text-primary font-medium">Other products</h6>
              <div className="text-white space-y-3">
                <a
                  href="https://enfinipay.com"
                  className="cursor-pointer hover:underline block"
                >
                  Pay
                </a>
                <a
                  href="https://enfiniboost.com"
                  className="cursor-pointer hover:underline block"
                >
                  Boost
                </a>
                <a
                  href="https://enfinishield.com"
                  className="cursor-pointer hover:underline block"
                >
                  Shield
                </a>
              </div>
            </div>
            <div className="space-y-3 w-full lg:w-72">
              <h6 className="text-primary font-medium">Case studies</h6>
              <div className="text-white space-y-3">
                {isCaseStudy ? (
                  <p
                    onClick={() => goUp()}
                    className="cursor-pointer hover:underline"
                  >
                    Content Operations (Viralish)
                  </p>
                ) : (
                  <Link
                    to={"/case-study-1"}
                    className="cursor-pointer hover:underline block"
                  >
                    <p>Content Operations (Viralish)</p>
                  </Link>
                )}
                {isCaseStudy2 ? (
                  <p
                    onClick={() => goUp()}
                    className="cursor-pointer hover:underline"
                  >
                    Content Operations (Viralish)
                  </p>
                ) : (
                  <Link
                    to={"/case-study-2"}
                    className="cursor-pointer hover:underline block"
                  >
                    <p>Content Protection (Twitch Creator)</p>
                  </Link>
                )}
              </div>
            </div>
            {/* <div className="space-y-3 w-full lg:w-72">
            <h6 className="text-primary font-medium">Pricing Plans</h6>
            <div className="text-white space-y-3">
              <p
                className="cursor-pointer hover:underline"
                onClick={() => handleNavClick("/pricing-plans", "subscription")}
              >
                Subscription Plan
              </p>
              <p
                className="cursor-pointer hover:underline"
                onClick={() => handleNavClick("/pricing-plans", "short-form")}
              >
                Short-form Editing
              </p>
              <p
                className="cursor-pointer hover:underline"
                onClick={() => handleNavClick("/pricing-plans", "long-form")}
              >
                Long-form Editing
              </p>
              <p
                className="cursor-pointer hover:underline"
                onClick={() => handleNavClick("/pricing-plans", "thumbnail")}
              >
                Thumbnail Design
              </p>
            </div>
          </div> */}
            {/* <div className="space-y-3 w-full lg:w-72">
            <h6 className="text-primary font-medium">Contact us</h6>
            <div className="text-white space-y-3">
              <a
                href="https://api.whatsapp.com/send/?phone=639291514853"
                className="cursor-pointer hover:underline block"
              >
                via Whatsapp
              </a>
              <a
                href="https://web.telegram.org/a/#6110481522"
                className="cursor-pointer hover:underline block"
              >
                via Telegram
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=requests@enfinity.com"
                className="cursor-pointer hover:underline block"
              >
                vie Email
              </a>
            </div>
          </div> */}
          </div>
        </div>
      </div>
      <SupportTicket modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  );
}
